import React from "react";
import {compose} from "recompose";
import {withStyles} from "material-ui/styles/index";
import styles from "./styles";
import {connect} from "react-redux";
import {Heading} from 'react-aria-components';
import {Button} from "../ui/react-aria/Button";
import {Modal} from "../ui/react-aria/Modal";
import {Dialog} from "../ui/react-aria/Dialog";
import {Form} from "../ui/react-aria/Form";
import {APIProvider, Map, Marker} from "@vis.gl/react-google-maps";
import {APP_CONFIG} from "../../config";

class DeviceLocationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isOpen !== this.props.isOpen || this.props.isOpen !== this.state.isOpen) {
      this.setState({isOpen: this.props.isOpen});
    }
  }

  onOpenChange = (isOpen) => {
    this.setState({isOpen});

    if (!isOpen) {
      const {onClose} = this.props;
      if (onClose) {
        onClose();
      }
    }
  };

  render() {
    const {classes, device} = this.props;
    const {isOpen} = this.state;

    const location = {lat: device.latitude, lng: device.longitude};
    const googleMapsApiKey = APP_CONFIG.googleMapsApiKey;

    return (
      <React.Fragment>
        <Modal className={classes.modal} isOpen={isOpen} isDismissable
               onOpenChange={(isOpen) => this.onOpenChange(isOpen)}>
          <Dialog>
            <div className={classes.root}>
              <Heading slot="title">{'Device Location'}</Heading>
              {googleMapsApiKey ? (
                <APIProvider apiKey={googleMapsApiKey}>
                  <Map
                    className={classes.map}
                    defaultCenter={location}
                    defaultZoom={16}
                    gestureHandling='greedy'
                    disableDefaultUI={false}
                  >
                    <Marker
                      position={location}
                      title={device.deviceserialno}
                    />
                  </Map>
                </APIProvider>
              ) : (
                <div className={classes.mapUnavailable}>
                  Google Maps is not configured for this environment.
                </div>
              )}
              <Form>
                <div className={classes.buttons}>
                  <Button slot="close" variant="secondary">Cancel</Button>
                </div>
              </Form>
            </div>
          </Dialog>
        </Modal>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(DeviceLocationModal);
